import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { AppState } from './store'

interface brukareDateSlice {
  from: string | null
  to: string | null
}

// null = användaren har inte valt datum ännu → vyn faller tillbaka på senaste körningens månad (#47).
// När ett datum väljs (eller seedas) lagras det här och bibehålls vid navigering.
const initialState = {
  from: null,
  to: null,
} as brukareDateSlice

const brukareDateSlice = createSlice({
  name: 'brukareDate',
  initialState,
  reducers: {
    setBrukareDate(state, action: PayloadAction<brukareDateSlice>) {
      return action.payload
    },
  },
})

export const getBrukareDateFrom = (state: AppState) => state.brukareDateReducer.from
export const getBrukareDateTo = (state: AppState) => state.brukareDateReducer.to
export const { setBrukareDate } = brukareDateSlice.actions
export default brukareDateSlice.reducer
